<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Intermediary Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryIntermediaryForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryIntermediaryForm"
                              v-model="filtersIntermediary.inter"
                              :label="filtersIntermediaryLabel.inter"
                              :error-messages="errors.collect('inter')"
                              data-vv-name="inter"
                              :data-vv-as="filtersIntermediaryLabel.inter"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryIntermediaryForm"
                              v-model="filtersIntermediary.intermediaryName"
                              :label="filtersIntermediaryLabel.intermediaryName"
                              :error-messages="errors.collect('intermediaryName')"
                              data-vv-name="intermediaryName"
                              :data-vv-as="filtersIntermediaryLabel.intermediaryName"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-card>
            <v-card-text>
              <v-data-table
                v-bind:headers="intermediaryHeaders"
                v-bind:items="items"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItemsIntermediary"
                v-bind:options.sync="paginationIntermediary"
                item-key="inter"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'inter')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'inter')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      actionName: '',
      filtersIntermediaryLabel: {
        inter: 'Intermediary',
        intermediaryName: 'Name'
      },
      filtersIntermediary: {
        inter: undefined,
        intermediaryName: undefined,
        group: undefined,
        interGrps: undefined,
        perDebtTran: undefined
      },
      items: [],
      totalItemsIntermediary: 0,
      intermediaryHeaders: [
        { text: 'Intermediary', align: 'left', value: 'inter' },
        { text: 'Name', value: 'name' }
      ],
      paginationIntermediary: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.fetchIntermediaryList()
  },
  methods: {
    doClearFilters() {
      this.filtersIntermediary.inter = ''
      this.filtersIntermediary.intermediaryName = ''
      this.filtersIntermediary.group = this.param
      this.filtersIntermediary.interGrps = this.interGrps
      this.filtersIntermediary.perDebtTran = this.perDebtTran
      this.fetchIntermediaryList()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryIntermediaryForm').then((result) => {
        if (result) {
          this.paginationIntermediary.page = 1
          this.filtersIntermediary.group = this.param
          this.filtersIntermediary.interGrps = this.interGrps
          this.fetchIntermediaryList()
        }
      })
    },
    async fetchIntermediaryList() {
      const apiUrl = this.$store.state.commons.menu.intermediaryList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationIntermediary
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.filtersIntermediary)
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationIntermediary.sortBy, this.paginationIntermediary.sortDesc))
          if (result.data) {
            this.items = []
            this.totalItemsIntermediary = result.data.totalElements
            const { data } = result.data
            if (data) {
              data.map((inter) => {
                const convertObj = {
                  key: inter.inter,
                  inter: inter.inter,
                  name: inter.name,
                  value: inter.inter
                }
                this.items.push(convertObj)
              })
            } else {

            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  watch: {
    'paginationIntermediary': function (value) {
      this.filtersIntermediary.interGrps = this.interGrps
      this.fetchIntermediaryList()
    },
    param: function (value) {
      this.doClearFilters()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, helpListMixin],
  props: {
    param: {
      type: String,
      default: ''
    },
    headerInfo: {
      type: String,
      default: ''
    },
    interGrps: {
      type: String,
      default: undefined
    },
    perDebtTran: {
      type: String,
      default: ''
    },
    menu: Object
  }
}
</script>

<style lang="scss">
</style>
